module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"title":{"edit":"리뷰를 수정합니다.","delete":"리뷰를 삭제합니다."},"password":{"placeholder":"리뷰를 작성시 설정한 비밀번호를 입력해주세요.","invalid":"비밀번호가 일치하지 않습니다. 다시 입력해주세요."},"submit":{"edit":"리뷰 수정","delete":"리뷰 삭제"}}}')
  delete Component.options._Ctor
}
